import React from "react"
import styled from "styled-components"

import { ReactComponent as NoResultSvg } from "../../static/images/noResult.svg"

interface Props {
  children?: React.ReactNode
}

const NoResultBox = styled.div`
  text-align: center;
  margin: ${(props) => props.theme.space.l} 0;
`

const NoResultImage = styled(NoResultSvg)`
  width: 120px;
  height: 120px;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.sm}) {
    width: 160px;
    height: 160px;
  }
`

const NoResultText = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.color.lightBlue};
`

const NoResult = (props: Props) => (
  <NoResultBox>
    <NoResultImage data-testid="universal-search-result-no-result-graphic" />
    <NoResultText data-testid="universal-search-result-no-result-text">
      {props.children}
    </NoResultText>
  </NoResultBox>
)

export default React.memo(NoResult)
